export default "__VITE_ASSET__1a877c30__"